<script setup lang="ts">
    import { computed } from 'vue';
    import { __ } from '@/js/stores/expressions';
    import CheckboxInput from '@/js/components/CheckboxInput.vue';
    import type { ImportTenantConfigOption } from '@/js/services/api/backOffice/types';

    const props = defineProps<{
        options: ImportTenantConfigOption[];
        modelValue: string[];
    }>();

    const emit = defineEmits<{
        'update:modelValue': [value: string[]];
    }>();

    const selectedConfigs = computed({
        get: () => props.modelValue,
        set: (value: string[]) => emit('update:modelValue', value),
    });

    const toggleConfig = (name: string, checked: boolean) => {
        if (checked) {
            if (!selectedConfigs.value.includes(name)) {
                selectedConfigs.value = [...selectedConfigs.value, name];
            }
        } else {
            selectedConfigs.value = selectedConfigs.value.filter((c) => c !== name);
        }
    };
</script>

<template>
    <fieldset v-if="options.length > 0">
        <legend class="text-overline mb-1 block">
            {{ __('back-office-configuration-options') }}
        </legend>
        <div class="flex flex-col gap-1">
            <CheckboxInput
                v-for="option in options"
                :id="`sync-config-option-${option.name}`"
                :key="option.name"
                :model-value="selectedConfigs.includes(option.name)"
                :disabled="!option.isEnabled"
                @update:model-value="toggleConfig(option.name, $event ?? false)"
            >
                {{ option.name }}
            </CheckboxInput>
        </div>
    </fieldset>
</template>
